module.exports = __webpack_public_path__ + "img/star 2.053eff8c.svg";